// import modalHelper from './util/modalHelper'


(function () {

  $('img[usemap="#ImageMap"]').rwdImageMaps();
  var fixedBody = function () {
    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    document.body.style.cssText += 'position:fixed;top:-' + scrollTop + 'px;';
  }

  var looseBody = function () {
    var body = document.body;
    body.style.position = '';
    var top = body.style.top;
    document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top, 10);
    body.style.top = '';
  }
  $('#imageMap.x_popup').find('area').colorbox({
    width: "93%",
    height: "auto",
    onOpen: function () {
      fixedBody();
    },
    onClosed: function () {
      looseBody();
    }
  });

  $('.x-icon-menu').on('click', function () {
    console.log('in')
    const $menuBord = $('.x-header-nav')

    if ($(this).hasClass('is-expand')) {
      looseBody();
    } else {
      fixedBody();
    }

    $(this).toggleClass('is-expand')
    $menuBord.toggleClass('is-expand')
  })

  $('.x-header-nav').on('touchmove', function (e) {
    e.preventDefault();
  })


  var bgm_path = './sound/';
  if (!$.cookie("bgm")) {
    $.cookie("bgm", "bgm_1.mp3");
  }
  console.log($.cookie("bgm"))
  var bgm_name = $.cookie("bgm") || "bgm_1.mp3";


  var stream = {
    mp3: bgm_path + bgm_name
  },
  ready = false;
  
  var setVideostream = function (_bgm_name) {
    stream.mp3 = bgm_path + _bgm_name
  }
  console.log(stream);
  $("#jquery_jplayer_1").jPlayer({
    ready: function (event) {
      ready = true;
      $(this).jPlayer("setMedia", stream).jPlayer('stop');

      $(".x_video").click(function (e) {
        e.preventDefault();
        // console.log(stream.mp3, $(this).attr('href'))
        if ($(this).hasClass('is_active')) {
          $(".x_video").removeClass('is_active');
          $("#jquery_jplayer_1").jPlayer("setMedia", stream).jPlayer("pause");

        } else {
          $(".x_video").removeClass('is_active');
          $(this).addClass('is_active');
          setVideostream($(this).attr('href'));
          $("#jquery_jplayer_1").jPlayer("setMedia", stream).jPlayer("play");
        }
      })
    },
    pause: function () {
      $.cookie("bgm_status", "pause");

    },
    play: function () {
      $.cookie("bgm_status", "play");
      // $('.video-item a').click(function() {
      //   // $("#jquery_jplayer_1").jPlayer("pause");
      // });
    },
    error: function (event) {
      console.log('error');
      if (ready && event.jPlayer.error.type === $.jPlayer.error.URL_NOT_SET) {
        $(this).jPlayer("setMedia", stream).jPlayer("play");
      }
    },
    ended: function () {
      console.log('ended');
      $(this).jPlayer("setMedia", stream).jPlayer("play");
    },
    swfPath: "js",
    supplied: "mp3",
    preload: "none",
    wmode: "window",
    loop: true,
    volume: 1,
    keyEnabled: true
  });

})();

